/* Skinny Genie redesign: product detail page interactions (gallery, zoom, qty, recommendations). */

function pdpSwapImage(btn, url, fullUrl){
  document.querySelectorAll('.pdp-gallery-thumbs button').forEach(function(b){ b.classList.remove('active'); });
  btn.classList.add('active');
  var mainImg = document.getElementById('pdp-main-img');
  if(mainImg){
    mainImg.src = url;
    mainImg.setAttribute('data-full', fullUrl || url);
  }
}

var pdpZoomImages = [];
var pdpZoomIndex = 0;

function pdpOpenZoom(){
  var overlay = document.getElementById('pdp-zoom-overlay');
  var img = document.getElementById('pdp-zoom-img');
  if(!overlay || !img) return;
  var mainImg = document.getElementById('pdp-main-img');
  var current = mainImg ? (mainImg.getAttribute('data-full') || mainImg.src) : '';
  pdpZoomIndex = pdpZoomImages.indexOf(current);
  if(pdpZoomIndex < 0) pdpZoomIndex = 0;
  pdpRenderZoom();
  overlay.classList.add('open');
  document.body.classList.add('pdp-zoom-locked');
}

function pdpRenderZoom(){
  var img = document.getElementById('pdp-zoom-img');
  if(!img || !pdpZoomImages.length) return;
  img.src = pdpZoomImages[pdpZoomIndex];
  var prev = document.getElementById('pdp-zoom-prev');
  var next = document.getElementById('pdp-zoom-next');
  if(prev) prev.disabled = pdpZoomIndex <= 0;
  if(next) next.disabled = pdpZoomIndex >= pdpZoomImages.length - 1;
}

function pdpZoomNav(dir){
  pdpZoomIndex = Math.max(0, Math.min(pdpZoomImages.length - 1, pdpZoomIndex + dir));
  pdpRenderZoom();
}

function pdpCloseZoom(){
  var overlay = document.getElementById('pdp-zoom-overlay');
  if(overlay) overlay.classList.remove('open');
  document.body.classList.remove('pdp-zoom-locked');
}

function renderPdpUrgency(){
  var el = document.getElementById('pdp-urgency');
  if(!el) return;
  var clockSvg = '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>';
  var now = new Date();
  var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 17, 30, 0);
  if(now < cutoff){
    el.innerHTML = clockSvg + 'Order before 5:30pm for same-day Dubai delivery';
  } else {
    el.innerHTML = clockSvg + 'Order now for next-day delivery';
  }
}

function pdpUpdateFbtTotal(){
  var row = document.getElementById('pdp-fbt-row');
  var totalEl = document.getElementById('pdp-fbt-total-price');
  if(!row || !totalEl) return;
  var total = 0;
  row.querySelectorAll('input[type="checkbox"]').forEach(function(cb){
    if(cb.checked){ total += parseInt(cb.getAttribute('data-fbt-price'), 10) || 0; }
  });
  totalEl.textContent = sgMoney(total);
}

function pdpAddFbtToCart(mainVariantId){
  var row = document.getElementById('pdp-fbt-row');
  if(!row) return;
  var items = [];
  row.querySelectorAll('input[type="checkbox"]').forEach(function(cb){
    if(!cb.checked) return;
    var variantId = cb.hasAttribute('data-fbt-variant-id') ? parseInt(cb.getAttribute('data-fbt-variant-id'), 10) : mainVariantId;
    items.push({ id: variantId, quantity: 1 });
  });
  if(!items.length) return;
  fetch(window.routes.cart_add_url + '.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({ items: items })
  })
    .then(function(r){ return r.json(); })
    .then(function(){ return sgFetchCart(); })
    .then(function(cart){ updateCartUI(cart); openCartDrawer(); });
}

/* Mirrors Judge.me's real rating state into our own headings. The widget is
   client-rendered, so these values only exist once the app has hydrated. */
function pdpSyncReviewSummary(){
  var widg = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg');
  if(!widg) return false;
  var count = parseInt(widg.getAttribute('data-number-of-reviews'), 10) || 0;
  var average = parseFloat(widg.getAttribute('data-average-rating')) || 0;
  var summaryEl = document.getElementById('pdp-review-summary');
  var countEl = document.getElementById('pdp-reviews-count');
  if(summaryEl){
    summaryEl.textContent = count > 0 ? average.toFixed(1) + ' out of 5' : 'No ratings yet';
  }
  if(countEl){
    countEl.textContent = 'Customer reviews (' + count + ')';
  }
  return true;
}

function pdpWatchReviewWidget(){
  var host = document.getElementById('judgeme_product_reviews');
  if(!host || pdpSyncReviewSummary()) return;
  var observer = new MutationObserver(function(){
    if(pdpSyncReviewSummary()) observer.disconnect();
  });
  observer.observe(host, { childList: true, subtree: true });
}

/* Opens Judge.me's own review form: the app owns review storage, so reusing its
   link is what makes a submitted review actually save. */
function pdpOpenReviewForm(){
  var widget = document.getElementById('judgeme_product_reviews');
  if(!widget) return;
  widget.scrollIntoView({ block: 'center', behavior: 'smooth' });
  var link = widget.querySelector('.jdgm-write-rev-link');
  if(link) link.click();
}

function scrollPdpRec(dir){
  var track = document.getElementById('pdp-rec-track');
  if(!track) return;
  track.scrollBy({ left: dir * 260, behavior: 'smooth' });
}

function updatePdpRecArrows(){
  var track = document.getElementById('pdp-rec-track');
  var prev = document.getElementById('pdp-rec-prev');
  var next = document.getElementById('pdp-rec-next');
  if(!track || !prev || !next) return;
  prev.disabled = track.scrollLeft <= 4;
  next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
}


/* ---------- Favourite control on the product page ----------

   Deliberately here and not in skinny-genie-base.js: this is PDP-only markup,
   and base.js does not need to know the product page exists. It reuses
   toggleFavourite() and getFavourites() from base.js, which loads first, so the
   header badge, the mobile nav count and the favourites drawer all update
   themselves with no extra wiring.

   The paint is driven off the STORED list rather than off the click, so the
   label can never disagree with what is actually saved. */
function sgPdpFavPaint(btn, on){
  if(!btn){ return; }
  btn.classList.toggle('active', on);
  btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  /* Icon only, as the mockups have it, so the state has to reach assistive
     tech through the label rather than through visible text. */
  btn.setAttribute('aria-label', on ? 'Remove from favourites' : 'Add to favourites');
}
function initPdpFav(){
  var btn = document.querySelector('.pdp-fav[data-handle]');
  if(!btn || typeof getFavourites !== 'function'){ return; }
  sgPdpFavPaint(btn, getFavourites().indexOf(btn.getAttribute('data-handle')) !== -1);
}
function sgPdpToggleFav(btn){
  var handle = btn.getAttribute('data-handle');
  if(!handle || typeof toggleFavourite !== 'function'){ return; }
  toggleFavourite(handle);
  initPdpFav();
}
/* Removing THIS product from inside the favourites drawer has to repaint the
   button behind it. Without this the label still reads "Saved to favourites"
   over a list that no longer contains it, and the next tap would silently
   re-add rather than remove, which is a wrong state rather than a cosmetic
   one. Delegated and scoped to the drawer so the PDP keeps ownership of its own
   sync; base.js stays unaware of it. The timeout lets favDrawerRemove finish
   writing localStorage before the list is read back.

   CAPTURE PHASE, and that is not incidental. favDrawerRemove re-renders the
   drawer synchronously, and when it was the last favourite that path sets
   itemsEl.innerHTML = '' straight away, which DETACHES the Remove button that
   was clicked. On the way back up e.target is then an orphan whose closest()
   walk finds no '#fav-drawer' ancestor, so a bubble-phase listener silently
   never matched. Measured on the draft 2026-09-23: sg_favourites went to []
   and the header badge hid, while the button still read "Saved to favourites"
   with aria-pressed="true". Capture runs on the way DOWN, before any of that,
   so the node is still in the tree. */
document.addEventListener('click', function(e){
  if(e.target && e.target.closest && e.target.closest('#fav-drawer')){
    setTimeout(initPdpFav, 0);
  }
}, true);

/* ---------- Variant picker ----------

   Only products with real options render the markup this drives, so on every
   single-variant product these functions find nothing and return immediately.

   Matching is done on the OPTION VALUES rather than on an index, so it works
   for any number of options. Shopify gives each variant an `options` array in
   the same order as product.options_with_values, and the checked radios are
   read in document order, so the two line up positionally.

   Money comes from the embedded JSON, which Liquid formatted with the `money`
   filter, so a swapped price is rendered exactly as the server would render it
   and cannot drift from the rest of the page. */
function sgPdpVariantData(){
  var el = document.getElementById('pdp-variant-data');
  if(!el){ return null; }
  try{ return JSON.parse(el.textContent); }catch(e){ return null; }
}
function sgPdpChosenOptions(){
  return [].map.call(document.querySelectorAll('.pdp-variant-input:checked'), function(i){ return i.value; });
}
function sgPdpFindVariant(variants, chosen){
  for(var i = 0; i < variants.length; i++){
    var opts = variants[i].options;
    if(opts.length !== chosen.length){ continue; }
    var hit = true;
    for(var j = 0; j < opts.length; j++){
      if(opts[j] !== chosen[j]){ hit = false; break; }
    }
    if(hit){ return variants[i]; }
  }
  return null;
}
/* Greys out a value that cannot be bought GIVEN THE OTHER CHOICES, which is why
   it compares every position except the one being tested rather than just
   looking for any available variant carrying the value. */
function sgPdpMarkUnavailable(variants, chosen){
  document.querySelectorAll('.pdp-variant-pill[data-option-index]').forEach(function(pill){
    var idx = parseInt(pill.getAttribute('data-option-index'), 10);
    var value = pill.getAttribute('data-value');
    var possible = variants.some(function(v){
      if(!v.available || v.options[idx] !== value){ return false; }
      for(var j = 0; j < chosen.length; j++){
        if(j !== idx && v.options[j] !== chosen[j]){ return false; }
      }
      return true;
    });
    pill.classList.toggle('sg-unavailable', !possible);
  });
}
function sgPdpVariantChange(){
  var variants = sgPdpVariantData();
  if(!variants || !variants.length){ return; }
  var chosen = sgPdpChosenOptions();
  var match = sgPdpFindVariant(variants, chosen);
  sgPdpMarkUnavailable(variants, chosen);
  if(!match){ return; }

  /* Rebuilt rather than assigned to textContent, because a sale price carries a
     .pdp-price-was span inside the same element and textContent would eat it.
     The struck-through former price is per variant, so it has to be re-derived,
     not preserved. */
  var priceEl = document.querySelector('.pdp-price');
  if(priceEl){
    if(match.compareAt){
      priceEl.innerHTML = match.price + ' <span class="pdp-price-was">' + match.compareAt + '</span>';
    } else {
      priceEl.textContent = match.price;
    }
  }

  /* The "Save AED X" sale line above the price follows the chosen size. */
  var dealEl = document.getElementById('pdp-deal-tag');
  var dealAmount = document.getElementById('pdp-deal-amount');
  if(dealEl && dealAmount){
    if(match.compareAt && match.save){
      dealAmount.textContent = match.save;
      dealEl.hidden = false;
    } else {
      dealEl.hidden = true;
    }
  }

  /* Both sticky bars carry the price too, so all three have to move together
     or the bar quotes the size you are no longer looking at. */
  document.querySelectorAll('.js-pdp-sticky-price').forEach(function(el){
    el.textContent = match.price;
    /* Sale prices are red everywhere, the sticky bars included. */
    el.classList.toggle('is-sale', !!match.compareAt);
  });

  var weightEl = document.getElementById('pdp-weight');
  if(weightEl && match.title && match.title !== 'Default Title'){
    weightEl.textContent = match.title;
  }

  /* EVERY buy control is reset to a plain Add button and then re-hydrated, so
     if the newly chosen variant is ALREADY in the cart it comes back as a
     stepper showing that variant's quantity. Without the reset the stepper left
     over from the previous variant would keep stepping the wrong line.

     All three of them: the inline row, the mobile sticky bar and the desktop
     sticky top bar. Only one is visible at a time, but the hidden ones must not
     be left pointing at the old variant. */
  document.querySelectorAll('.pdp-buy-row .bs-add-wrap, .pdp-sticky-buy .bs-add-wrap, .pdp-sticky-top .bs-add-wrap').forEach(function(wrap){
    wrap.setAttribute('data-variant-id', match.id);
    if(match.available){
      wrap.innerHTML = '<button type="button" class="bs-btn" onclick="event.preventDefault(); event.stopPropagation(); bsCardAdd(this, ' + match.id + ');">Add to cart</button>';
    } else {
      wrap.innerHTML = '<button type="button" class="bs-btn" disabled>Sold out</button>';
    }
  });
  if(match.available && typeof bsHydrateCardButtons === 'function'){ bsHydrateCardButtons(); }

  /* Puts the choice in the URL, so a refresh, a share or a back button lands on
     the same variant. replaceState rather than pushState: picking a size is not
     a new page and should not need a back press to undo. */
  try{
    var url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url.toString());
  }catch(e){}

  if(typeof sgReapply === 'function'){ sgReapply(); }
}

/* The desktop sticky top bar appears only once the real buy row has scrolled
   completely off the top, so it never duplicates a control that is already on
   screen. Mobile does not use it at all: below 900px the bar is pinned to the
   bottom and is always on, and the CSS media queries make the two mutually
   exclusive rather than the JS having to decide.

   IntersectionObserver rather than a scroll listener. It is the right tool for
   "has this element left the viewport": the browser evaluates it off the main
   thread, it fires once on observe so the initial state is free, and it does
   not run a handler on every scroll frame.

   It also happens to be testable. The mockup used window.addEventListener
   ('scroll'), which was ported as-is, and it could not be verified on the draft
   at all: an independent probe listener attached on 2026-09-23 counted ZERO
   scroll events while window.scrollY genuinely moved 0 to 1500 and the row's
   rect updated to -985. Whatever swallows them, a scroll-driven version cannot
   be checked here, and shipping an unverifiable buy control is not worth it.

   The bottom < 0 test still matters alongside isIntersecting: the row also
   stops intersecting when it leaves through the BOTTOM, and the bar must not
   appear then. The scroll fallback is kept for anything without the API. */
function sgPdpInitStickyTop(){
  var bar = document.getElementById('pdp-sticky-top');
  var row = document.getElementById('pdp-buy-row');
  if(!bar || !row){ return; }
  function show(on){ bar.classList.toggle('visible', !!on); }
  if(typeof IntersectionObserver === 'function'){
    new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        show(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      });
    }, {threshold: 0}).observe(row);
    return;
  }
  function sync(){ show(row.getBoundingClientRect().bottom < 0); }
  window.addEventListener('scroll', sync, {passive: true});
  window.addEventListener('resize', sync, {passive: true});
  sync();
}

document.addEventListener('DOMContentLoaded', function(){
  var mainImg = document.getElementById('pdp-main-img');
  if(mainImg){
    pdpZoomImages = Array.from(document.querySelectorAll('.pdp-gallery-thumbs button')).map(function(b){
      return b.getAttribute('data-full-url');
    }).filter(Boolean);
  }
  var track = document.getElementById('pdp-rec-track');
  if(track){
    track.addEventListener('scroll', updatePdpRecArrows);
    updatePdpRecArrows();
  }
  /* renderPdpUrgency() is no longer called: the same-day / next-day line under
     the price was removed at the user's request (2026-10-05). */
  pdpWatchReviewWidget();
  initPdpFav();
  /* Paints the initial unavailable state; does not change the selection. */
  sgPdpVariantChange();
  sgPdpInitStickyTop();
});
